<template>
    <div class="forgot-password absolute inset-0 flex items-center justify-center">
        <div class="forgot-password-box bg-white rounded-lg flex flex-col items-center justify-center">
            <img class="forgot-password-logo cursor-pointer" src="@/assets/images/auth-logo.svg"
            @click="$router.push({ name: 'Auth' })">
            
            <img class="forgot-password-illus rounded-full" src="@/assets/images/auth-illus.jpg">

            <div
            class="forgot-password-form flex flex-col items-center justify-evenly border border-blue rounded-md"
            @keyup.enter="submit">
                <h1 v-if="!showConfirmation" class="uppercase text-xs font-main-bold">Mot de passe oublié</h1>
                
                <div v-if="!showConfirmation" class="forgot-password-inputs border border-blue border-opacity-20 rounded">
                    <input class="placeholder-gray" type="text" name="email" placeholder="Email" v-model="email" :disabled="hasPendingRequest">
                </div>

                <div v-else>
                    <p>Merci !</p>
                    <p>Un email vous a été envoyé avec les instructions pour réinitialiser votre mot de passe.</p>
                </div>

                <button
                v-if="!showConfirmation"
                type="submit" 
                class="forgot-password-submit faa-button-blue"
                :class="{
                    'loading': hasPendingRequest
                }"
                :disabled="hasPendingRequest || !isEmailValid"
                @click.prevent="submit">
                    Valider
                    <div class="faa-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'ForgotPassword',
        data() {
            return {
                hasPendingRequest: false,
                showConfirmation: false,
                email: '',
            }
        },
        computed: {
            isEmailValid() {
                // Check email value
                const re = /\S+@\S+\.\S+/
                const email = (this.email ? this.email.trim() : null)

                return (email && email.length > 0 && re.test(email))
            },
        },
        methods: {
            ...mapActions('Auth', ['forgotPassword']),
            async submit() {
                if (this.hasPendingRequest || !this.isEmailValid)
                    return

                this.hasPendingRequest = true

                const result = await this.forgotPassword(this.email)

                if (result !== false) {
                    this.showConfirmation = true
                }

                this.hasPendingRequest = false
            },
        },
    }
</script>

<style lang="scss" scoped>

.forgot-password {
    .forgot-password-box {
        width: 40%;
        height: 90%;
        max-width: 672px;
        max-height: 960px;

        .forgot-password-logo {
            height: 7.2%;
            margin-bottom: 8%;
        }

        .forgot-password-illus {
            height: 28%;
            margin-bottom: 8.7%;
        }

        .forgot-password-form {
            padding: 0 7.4%;
            width: 80%;
            height: 40%;

            button, input {
                @apply block appearance-none;

                &:focus {
                    @apply outline-none;
                }
            }

            .forgot-password-inputs {
                width: 100%;

                input {
                    @apply w-full bg-transparent m-auto px-4 py-3 text-sm;
                } 
            }

            .forgot-password-submit {
                button:focus {
                    @apply shadow-outline;
                }
            }
        }
    }
}

</style>
